import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Task } from '@repo/shared';

import Combobox, { type ComboboxProps } from '@/components/ui/combobox';

type TaskComboboxProps = Omit<ComboboxProps<false>, 'options'>;

const TaskCombobox: FC<TaskComboboxProps> = (props) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => [
      {
        label: t('enums.task.textTranslation'),
        value: Task.TEXT_TRANSLATION,
      },

      {
        label: t('enums.task.extractStructure'),
        value: Task.EXTRACT_STRUCTURE,
      },
      {
        label: t('enums.task.describeImage'),
        value: Task.DESCRIBE_IMAGE,
      },
      {
        label: t('enums.task.generateAudio'),
        value: Task.GENERATE_AUDIO,
      },
    ],
    [t]
  );

  return (
    <Combobox
      {...props}
      placeholder={t('components.taskCombobox.placeholder')}
      options={options}
    />
  );
};

export default TaskCombobox;
